import Vue from 'vue';
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import { Validator } from 'vee-validate';
export default function () {
  this.staffEmploymentValidation = function () {
    const dictonary = {
      custom: {
        jobCode: {
          required: () => t.t(dictEnum.LBL_JobCode) + t.t(dictEnum.WARN_IsRequired)
        },
        emTitle: {
          required: () => t.t(dictEnum.LBL_Title) + t.t(dictEnum.WARN_IsRequired)
        },
        Salary: {
          required: () => t.t(dictEnum.LBL_Salary) + t.t(dictEnum.WARN_IsRequired),
          integer: () => t.t(dictEnum.LBL_Salary)
        },
        empType: {
          required: () => t.t(dictEnum.LBL_Type) + t.t(dictEnum.WARN_IsRequired)
        },
        grade: {
          required: () => t.t(dictEnum.LBL_Grade) + t.t(dictEnum.WARN_IsRequired)
        },
        EmpStatus: {
          required: () => t.t(dictEnum.LBL_Status) + t.t(dictEnum.WARN_IsRequired)
        },
        Dept: {
          required: () => t.t(dictEnum.LBL_Department) + t.t(dictEnum.WARN_IsRequired)
        },
        TeamCode: {
          required: () => t.t(dictEnum.LBL_Team) + t.t(dictEnum.WARN_IsRequired)
        },
        HisSalary: {
          required: () => t.t(dictEnum.LBL_Salary) + t.t(dictEnum.WARN_IsRequired),
          integer: () => t.t(dictEnum.LBL_SalaryNum)
        },
        hisTitle: {
          required: () => t.t(dictEnum.LBL_Title) + t.t(dictEnum.WARN_IsRequired)
        },
        hisDateTx: {
          required: () => t.t(dictEnum.LBL_Date) + t.t(dictEnum.WARN_IsRequired)
        },
        DateJoin: {
          required: () => t.t(dictEnum.LBL_StartDate) + t.t(dictEnum.WARN_IsRequired)
        },
        DateProbatEnd: {
          required: () => t.t(dictEnum.LBL_DateProbatEnd) + t.t(dictEnum.WARN_IsRequired)
        },
      }
    };
    Validator.localize('en', dictonary);
  }
}



// WEBPACK FOOTER //
// ./src/components/S070000-Employee/S070200-EmployeeProfile/S070200-EmploymentValidation.js